import { Alert, Row, type TFormMethods } from "@fluidattacks/design";
import { useTranslation } from "react-i18next";

import { ArrayFields } from "./field";
import { policyOptions } from "./utils";

import type { IPolicyCriteria } from "../../types";

interface IAddPriorityCriteriaProps
  extends Pick<
    TFormMethods<IPolicyCriteria>,
    "control" | "setValue" | "register" | "watch"
  > {
  readonly criteriaName: string;
}
export const AddPriorityCriteria = ({
  criteriaName,
  control,
  setValue,
  register,
  watch,
}: IAddPriorityCriteriaProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Row align={"spa"}>
      <ArrayFields
        addText={t("organization.tabs.policies.priority.modal.addCriterion")}
        control={control}
        max={1000}
        min={-1000}
        options={policyOptions(criteriaName)}
        placeholder={t("organization.tabs.policies.priority.modal.placeholder")}
        register={register}
        setValue={setValue}
        watch={watch}
      />
      <Alert variant={"warning"}>
        {t("organization.tabs.policies.priority.modal.help")}
      </Alert>
    </Row>
  );
};
